import React from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import FeaturedBook from '@/components/FeaturedBook';
import PeekInside from '@/components/PeekInside';
import Resources from '@/components/Resources';
import Newsletter from '@/components/Newsletter';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import '@/App.css';

export default function App() {
  return (
    <div className="App bg-[#FBF7F2] text-[#24385C]">
      <Header />
      <main>
        <Hero />
        <About />
        <FeaturedBook />
        <PeekInside />
        <Resources />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
